<template>
    <div class="recover-password flex-center" :class="providerClasses">
        <v-card class="modal modal-round">
            <button
                type="button"
                class="recover-password-return"
                :style="{ color: providerColor }"
                @click="emitBack"
            >
                <i class="mdi mdi-arrow-left pointer"></i>
            </button>

            <div class="logo-wrapper flex-center">
                <img :src="logoUrl" :class="{ 'logo-wifeed': usesNewLogo }" :alt="savedProvider" class="logo" />
            </div>

            <p class="recover-password-title">
                {{ $t("message.login.message.redefinePassword") }}
            </p>
            <p class="recover-password-text">
                {{ $t("message.login.message.enterEmail") }}
            </p>

            <form class="form" @submit.prevent="checkEmail">
                <v-text-field
                    v-model="email"
                    :label="$t('message.login.message.email')"
                    class="font-lg"
                ></v-text-field>

                <button class="btn btn-primary btn-extra-round">
                    {{ $t("message.login.message.redefinePassword") }}
                </button>
            </form>
        </v-card>
        <vue-recaptcha
            @verify="onVerifyCaptcha"
            ref="recaptcha"
            size="invisible"
            :loadRecaptchaScript="true"
            sitekey="6LfD48YUAAAAAPJ2LiZ86AloaAMg5Yq9ZZQyo69-"
        >
        </vue-recaptcha>
    </div>
</template>

<script>
import EventBus from "@packages/event-bus";
import VueRecaptcha from "vue-recaptcha";
import provider from "@mixins/provider";

export default {
    components: {
        VueRecaptcha,
    },

    mixins: [provider],

    data() {
        return {
            email: "",
        };
    },

    computed: {
        providerClasses() {
            return {
                "login_custom-provider": this.isCustomProvideLogin,
                "login-wcs": this.savedProvider === "wcs",
                "login-haggi": this.savedProvider === "haggi",
                "login-tely": this.savedProvider === "tely",
                "login-ntcorp": this.savedProvider === "ntcorp",
                "login-data-carrier": this.savedProvider === "data-carrier",
                "login-vivo": this.savedProvider === "vivo",
                "login-vero": this.savedProvider === "vero",
                "login-unifique": this.savedProvider === "unifique",
                "login-abc": this.savedProvider === "abc",
            };
        },
    },

    methods: {
        onVerifyCaptcha: function (response) {
            this.sendEmail(response);
        },
        emitBack() {
            return this.$emit("back");
        },

        async checkEmail() {
            if (!this.email) {
                EventBus.$emit("show-message", {
                    type: "ERROR",
                    message: this.$t(
                        "message.errorMessages.message.enterEmail"
                    ),
                });
                return;
            }
            this.$refs.recaptcha.execute();
        },

        async sendEmail(keycaptcha) {
            try {
                await this.$api.auth.forgotPassword({
                    email: this.email,
                    captcha: keycaptcha,
                });

                EventBus.$emit("show-message", {
                    type: "SUCCESS",
                    message: "O link para redefinição de senha foi enviado",
                    timeout: 3000,
                });
            } catch (error) {
                console.log(error);
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.recover-password {
    width: 100vw;
    height: 100vh;
    background: $primary;

    .recover-password-return {
        position: absolute;
        top: 35px;
        left: 35px;
        z-index: 100;

        i {
            font-size: 30px;
        }
    }

    .recover-password-title {
        font-weight: 600;
        color: $color-muted;
        text-align: center;
        font-size: 28px;
    }

    .recover-password-text {
        color: #707070;
        text-align: center;
        font-weight: 600;
    }

    .modal {
        max-width: 500px;
        padding: 42px;
        flex-direction: column;

        .logo-wrapper {
            width: 100%;
            margin-bottom: 42px;

            .logo {
                height: 92px;

                &.logo-wifeed {
                    max-width: 197px;
                    height: auto;
                }
            }
        }

        .form {
            text-align: center;

            & > *:not(:last-child) {
                margin-bottom: 22px !important;
            }

            .btn {
                font-size: 18px;
                text-transform: uppercase;
                padding: 8px 42px;
            }
        }
    }

    .forgot-password {
        cursor: pointer;
    }

    &.login-wcs {
        background: rgb(255, 153, 0);
        background: linear-gradient(
            90deg,
            rgba(255, 153, 0, 1) 0%,
            rgba(243, 146, 0, 1) 50%,
            rgba(213, 118, 0, 1) 100%
        );
    }

    &.login-haggi {
        background: #2ebeb1;
    }

    &.login-tely {
        background: #0048fd;
    }

    &.login-ntcorp {
        background: #2e3b56;
    }

    &.login-data-carrier {
        background: #365176;

        .logo {
            background-color: #365176;
            padding: 10px;
            border-radius: 5px;
        }
    }

    &.login-vivo {
        background: #660099;

        .logo {
            width: 180px;
            height: 102px !important;
        }
    }

    &.login-vero {
        background: #29377f;
    }

    &.login-abc {
        background: #5f1319;
    }

    &.login-unifique {
        background: #212492;
    }
}
</style>
